var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 41.1666C25.5697 41.1691 25.1484 41.0434 24.7897 40.8055C24.4311 40.5676 24.1515 40.2283 23.9864 39.8308C23.8214 39.4334 23.7785 38.9958 23.8631 38.5738C23.9478 38.1518 24.1562 37.7647 24.4617 37.4616L35.9451 25.9999L24.4617 14.5383C24.1068 14.1238 23.9213 13.5906 23.9424 13.0453C23.9634 12.5 24.1895 11.9828 24.5753 11.5969C24.9612 11.211 25.4785 10.985 26.0238 10.9639C26.5691 10.9428 27.1022 11.1283 27.5167 11.4833L40.5167 24.4833C40.9203 24.8892 41.1468 25.4384 41.1468 26.0108C41.1468 26.5832 40.9203 27.1323 40.5167 27.5383L27.5167 40.5383C27.1132 40.9386 26.5685 41.1642 26.0001 41.1666Z",
    fill: "#2874F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 41.1667C12.5697 41.1692 12.1484 41.0434 11.7897 40.8055C11.4311 40.5676 11.1515 40.2283 10.9864 39.8309C10.8214 39.4334 10.7785 38.9958 10.8631 38.5739C10.9478 38.1519 11.1562 37.7647 11.4617 37.4617L22.9451 26L11.4617 14.5383C11.0537 14.1303 10.8245 13.577 10.8245 13C10.8245 12.423 11.0537 11.8697 11.4617 11.4617C11.8697 11.0537 12.4231 10.8245 13.0001 10.8245C13.5771 10.8245 14.1304 11.0537 14.5384 11.4617L27.5384 24.4617C27.9419 24.8676 28.1685 25.4168 28.1685 25.9892C28.1685 26.5616 27.9419 27.1107 27.5384 27.5167L14.5384 40.5167C14.3377 40.7214 14.0984 40.8843 13.8344 40.9958C13.5703 41.1074 13.2867 41.1655 13.0001 41.1667Z",
    fill: "#2874F0",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.34d8808896393226361b8a09543e630b.svg";
export { ForwardRef as ReactComponent };